import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "campaigns", label: "our work" },
  { id: "services", label: "Services" },
  { id: "reels", label: "Reels" },
  { id: "team", label: "Team" },
  { id: "testimonials", label: "Voices" },
  { id: "contact", label: "Contact Us" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-black/10"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-16 h-16 md:h-20 flex items-center justify-between relative">
        <a href="#top" data-testid="nav-logo">
          <img
            src="/images/dotMediaLogo.png"
            alt="Dot Media"
            className="h-12 md:h-16 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              className="text-[12px] tracking-[0.18em] uppercase font-semibold text-black/80 hover:text-[#E60000] transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          aria-label="Open menu"
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 text-black"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-black/10 px-6 py-6">
          <ul className="flex flex-col gap-4">
            {links.map((l) => (
              <li key={l.id}>
                <a
                  href={`#${l.id}`}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => setOpen(false)}
                  className="block text-base tracking-[0.18em] uppercase font-semibold py-2 border-b border-black/10"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Nav;
